import { useEffect } from "react";
import { SEOHead } from '@/components/seo/SEOHead';
import { Layout } from "@/components/layout/Layout";
import { FirstPurchaseCouponPopup } from "@/components/marketing/FirstPurchaseCouponPopup";
import { AnnouncementBar } from "@/components/home/AnnouncementBar";
import { HomeReviews } from "@/components/home/HomeReviews";
import { useProfessionalMode } from "@/components/enterprise/ProfessionalModeToggle";
import { trackGenericEvent } from "@/lib/crm/track";
import { HeroV2 } from "@/components/home/v2/HeroV2";
import { StorySection } from "@/components/home/v2/StorySection";
import { ColorSelector } from "@/components/home/v2/ColorSelector";
import { BestSellersV2 } from "@/components/home/v2/BestSellersV2";
import { RoutinePhotos } from "@/components/home/v2/RoutinePhotos";
import { LeftOutSection } from "@/components/home/v2/LeftOutSection";
import { FamilySize } from "@/components/home/v2/FamilySize";
import { KitsBento } from "@/components/home/v2/KitsBento";
import { TrustSection } from "@/components/home/v2/TrustSection";
import { CreatorsV2 } from "@/components/home/v2/CreatorsV2";
import { WhatsAppFaq } from "@/components/home/v2/WhatsAppFaq";
import { FounderV2 } from "@/components/home/v2/FounderV2";
import { MobileHomeBar } from "@/components/home/v2/MobileHomeBar";
import { ClientLogosStrip } from "@/components/brand/ClientLogosStrip";

const Index = () => {
  const { isProfessionalMode } = useProfessionalMode();

  useEffect(() => {
    try {
      trackGenericEvent("view_faq");
    } catch {}

    if (window.location.hash?.includes("access_token")) {
      window.location.replace(`/auth/callback${window.location.hash}`);
    }
  }, []);

  return (
    <Layout>
      <SEOHead
        title="Hidratante para pele sensível, sem perfume | NAT HOF"
        description="Hidratantes sem perfume para pele sensível e ressecada: corpo, mãos e pés. Testados em laboratório independente, notificados na ANVISA. Frete grátis para todo o Brasil."
        keywords="dermocosmético, pele sensibilizada, barreira cutânea, oncologia, gestação, pós-procedimento, hidratante dermoconstrutor, nat hof"
        canonicalUrl="https://nathof.com.br/"
        ogType="website"
      />

      <AnnouncementBar />

      {/* Cupom de 1ª compra: só após 30 s ou intenção de saída */}
      {!isProfessionalMode && <FirstPurchaseCouponPopup />}

      <div className="home-v2 bg-v2-bg overflow-x-hidden">
        <HeroV2 />
        <ClientLogosStrip />
        <StorySection />
        <ColorSelector />
        <BestSellersV2 />
        <RoutinePhotos />
        <LeftOutSection />
        <FamilySize />
        <KitsBento />
        <TrustSection />
        <HomeReviews />
        <FounderV2 />
        <CreatorsV2 />
        <WhatsAppFaq />
      </div>
      <MobileHomeBar />
    </Layout>
  );
};

export default Index;
